import { get } from 'radash';
import { colors } from '../css-library/tokens/reference';

/**
 * Get the theme color from a snake case color (originally from Prismic, but can be used in other contextes)
 * @param code the color code in snake case
 * @returns the hexadecimal theme color code
 */
const getThemeColor = (code: string): string | undefined => {
  const color = get(colors, code?.replace('_', '.') || '');

  if (typeof color !== 'string') {
    return undefined;
  }

  return color;
};

export default getThemeColor;
